module.exports = __webpack_public_path__ + "img/chevron-bar-right.9ac5b919.svg";